// ProjectPosts.js
import React, { useState, useEffect } from "react";
import {
    getFirestore,
    collection,
    query,
    where,
    getDocs,
    deleteDoc,
    doc,
    orderBy
} from "firebase/firestore";
import styles from '../ProjectPage.module.css'

export function ProjectPosts({ projectId }) {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const fetchProjectPosts = async () => {
            const db = getFirestore();
            const postsCollection = collection(db, "userPosts");

            // Updating the query to include ordering
            const q = query(
                postsCollection,
                orderBy("timestamp", "desc") // Ordering by timestamp in descending order
            );

            const querySnapshot = await getDocs(q);
            const allPostsData = [];
            querySnapshot.forEach((doc) => {
                allPostsData.push({ ...doc.data(), id: doc.id });
            });

            // Filtering posts by the specific projectId
            const projectSpecificPosts = allPostsData.filter(post => post.projectID === projectId);

            setPosts(projectSpecificPosts);
        };

        if (projectId) {
            fetchProjectPosts();
        }
    }, [projectId]);

    const handleDelete = async (postId) => {
        // Show a confirmation dialog
        if (window.confirm("Are you sure you want to delete this post from the project?")) {
            const db = getFirestore();
            await deleteDoc(doc(db, "userPosts", postId));
            // After deleting, remove the post from the local state
            setPosts(prevPosts => prevPosts.filter(post => post.id !== postId));
        }
    }

    return (
        <div >
         
            {posts.length === 0 ? (
                <div className={styles.projectPost}>
                    This project doesn't have any User posts yet.
                </div>
            ) : (
                posts.map((post) => (
                    <div key={post.id} className={styles.projectPost}>
                        {/* ... existing post rendering ... */}
                        <h3>{post.postTitle}</h3>
                        <p>{post.postDescription}</p>
                        <p>Posted on {new Date(post.timestamp).toLocaleString()}</p>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button onClick={() => handleDelete(post.id)} className={styles.deletePostButton}>
                                🗑️ Delete Post
                            </button>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}
